import { useCategoryContext } from "@components/Components/Providers/CategoryContext";
import { count } from "@components/config/helpers";
import useWindowSize from "@components/_hooks/useWindowSize";
import Grid from "@mui/material/Grid";
import dynamic from "next/dynamic";
const CategoryProductTile = dynamic(() => import("./CategoryProductTile"));
const CategorySkeletonTiles = dynamic(() => import("./CategorySkeletonTiles"), {
    ssr: false
});


const CategoryProducts = ({loadingProducts, template_page_settings, long_term, source}) => {
    const {
        categoryProducts: products,
        catData: props
    } = useCategoryContext();

    const {isMobile} = useWindowSize();

    if(loadingProducts) return ( <CategorySkeletonTiles template_page_settings={template_page_settings}/> )

    return (
        <>
            <Grid container className={`${isMobile && "pl-2 pr-2"} mt-0 mb-5`} spacing={isMobile ? 1 : 2} sx={{  transition: 'all 0.5s ease'}}  rowSpacing={{sm:12, lg:2 , md:2}}>
                {products &&
                    count(products) != 0 &&
                    products.map((product, idx) => (
                        <CategoryProductTile
                            key={idx}
                            long_term={long_term}
                            props={props}
                            product_idx={idx}
                            product={product}
                            source={source}
                            show_images={false}
                            gridProps={{
                                xl: 3, 
                                lg: 3, 
                                md: 3, 
                                sm: 6, 
                                xs: 6,
                            }}
                        />
                    )
                )}
            </Grid>
        </>
        
    )
}

export default CategoryProducts